import type { Vec2 } from '../../../geo/types';
import type { Landmark } from '../../../data/types';
import { conventRangeRect } from './conventRange';
import { corners } from './genericBlock';
import { toLayout, type PlanFrame } from './planFrame';
import reading from './kartuizersPlan.json';

export const KARTUIZERS = reading;

export function kartuizersFrame(landmark: Landmark): PlanFrame {
  const x = landmark.params['anchorX'],
    y = landmark.params['anchorY'];
  if (typeof x !== 'number' || typeof y !== 'number')
    throw new Error(`${landmark.id} lacks its charterhouse anchor`);
  return { origin: [x, y], heading: landmark.heading, ring: [] };
}

export function kartuizersPartFrame(
  plan: PlanFrame,
  part: { readonly u: number; readonly v: number; readonly angleDeg: number }
): PlanFrame {
  return {
    origin: toLayout(plan, [part.u, part.v]),
    heading: plan.heading + (part.angleDeg * Math.PI) / 180,
    ring: [],
  };
}

export const kartuizersChapel = () => ({ ...reading.chapel, apse: 'polygonal' as const });

export function kartuizersFloors(landmark: Landmark) {
  const plan = kartuizersFrame(landmark);
  return [
    ...reading.floors.map((f) => ({ ...f, ring: f.ring.map((p) => [p[0]!, p[1]!] as Vec2) })),
    ...reading.walks.map((w) => ({ ring: corners(w.rect), height: 0.065, garden: false })),
    ...reading.ranges
      .filter((p) => p.passage)
      .map((p) => ({
        ring: corners({ ...conventRangeRect(p), u0: -p.passage / 2, u1: p.passage / 2 }).map((q) =>
          toLayout({ origin: [p.u, p.v], heading: (p.angleDeg * Math.PI) / 180, ring: [] }, q)
        ),
        height: 0.05,
        garden: false,
      })),
  ].map((f) => ({ ...f, ring: f.ring.map((p) => toLayout(plan, p)) }));
}
